import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, Home } from "lucide-react";
import { Button } from "../components/ui/button";

export function ForbiddenPage() {
    return (
        <div
            className="min-h-screen bg-[#D6E6F2] flex items-center justify-center px-6"
            data-testid="forbidden-page"
        >
            <div className="max-w-md text-center">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#B8641F]/15 text-[#B8641F] mb-6">
                    <ShieldAlert size={28} />
                </div>
                <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#B8641F]">
                    403 · Forbidden
                </div>
                <h1 className="mt-2 font-serif text-4xl font-semibold text-[#0B2545]">
                    You don't have access to this area.
                </h1>
                <p className="mt-3 text-[#0E1B2C]/70">
                    Contact your platform admin if you believe this is a mistake.
                </p>
                <div className="mt-8">
                    <Link to="/app/dashboard" data-testid="forbidden-home-btn">
                        <Button className="rounded-full bg-[#0B2545] hover:bg-[#1E56A0] text-white">
                            <Home size={16} /> Back to dashboard
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export function NotFoundPage() {
    return (
        <div
            className="min-h-screen bg-[#D6E6F2] flex items-center justify-center px-6"
            data-testid="not-found-page"
        >
            <div className="max-w-md text-center">
                <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#1E56A0]">
                    404 · Not found
                </div>
                <h1 className="mt-2 font-serif text-4xl font-semibold text-[#0B2545]">
                    This page has drifted off the framework.
                </h1>
                <p className="mt-3 text-[#0E1B2C]/70">
                    The URL you typed doesn't map to any ESSS Coherence surface.
                </p>
                <div className="mt-8">
                    <Link to="/" data-testid="notfound-home-btn">
                        <Button className="rounded-full bg-[#0B2545] hover:bg-[#1E56A0] text-white">
                            <Home size={16} /> Take me home
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}
